//import liraries
import React, { Component, useEffect, useState } from "react";
import {
  View,
  ScrollView,
  FlatList,
} from "react-native";
import CustomButton from "../../common/CustomButton";
import CHeader from "../../common/CHeader";
import CImage from "../../common/CImage";
import CText from "../../common/CText";
import MainContainer from "../../common/CWrapper";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import TiDisputeCountCard from "./CommonComponants/TiDisputeCountCard";
import { COLORS, FONTS } from "../../constant";
import TiDisputeStatusCard from "./CommonComponants/TiDisputeStatusCard";
import TripDisputeDetailsCard from "./CommonComponants/TripDisputeDetailsCard";
import { tripIsuranceDisputeCount, tripIsuranceDisputeList } from "../../api/tripInsurance";
import { isEmpty } from "lodash";

// create a component
const TripDisputeHome = (props) => {
  const styles = useStyles();
  const [loading, setLoading] = useState(false);
  const [showDisputeDetails, setShowDisputeDetails] = useState(false);
  const [disputeData, setDisputeData] = useState([]);
  const [data, setData] = useState([]);
  const [disputeDetailData, setDisputeDetailData] = useState([]);

  useEffect(() => {
      getDisputeList();
      disputeCount()
  }, []);

  const getDisputeList = () => {
    setLoading(true)
    tripIsuranceDisputeList()
      .then((res) => {
        console.log('transaction------------------getDisputeList--------------', res);
        setData(res);
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      });
  };

  const disputeCount = () => {
    let params = {
      vrn: "",
      txnId: "",
      disputeStatus: "",
    };
    tripIsuranceDisputeCount(params)
      .then((res) => {
        console.log('transaction------------------transaction--------------', res);
        setDisputeData({ getDisputeCounts: res });
      })
      .catch((err) => {
        console.log("graphqltorest err", err);
      });
  };

  
  return (
    <MainContainer>
      <View style={styles.contentWrapper}>
        <CHeader
        showBack
        disputeHeader
        refresh
        onRefreshPress={getDisputeList}
          title="Trip Insurance Disputes"
          onPress={() => showDisputeDetails ? setShowDisputeDetails(false) : props.setScreen(props.info.backNavigation)}
          showDesc={true}
        />
        <View style={styles.contentViewStyle}>
          <View style={styles.firstViewStyle}>
            <CImage.DisputeImage />
            <View style={{ marginTop: 20 }}>
              <TiDisputeCountCard disputeData = {disputeData}/>
            </View>
            {
                !isEmpty(data) 
                &&  <View style={{ width: 170, height: 40, marginTop: 20 }}>
                <CustomButton
                skipButton
                  text={"+Raise New Dispute"}
                  onPress={() => props.setScreen("DisputeTransactions")}
                />
              </View>
            }
           
          </View>
          <View style={[styles.secondViewStyle]}>
            {isEmpty(data) ? (
              <View style={{ alignItems: "center", justifyContent: "center", marginTop: 40, }}>
                <CImage.Ti24SCancelImage />
                <CText.kycTypeText
                  style={{ color: COLORS.black, paddingVertical: 20 }}
                >
                  {"No Disputes Found"}
                </CText.kycTypeText>
                <CText.kycTypeText
                  style={{
                    color: COLORS.black,
                    paddingBottom: 20,
                    opacity: 0.5,
                    fontFamily: FONTS.InterMedium,
                    paddingHorizontal: 60,
                    textAlign: "center",
                  }}
                >
                  {
                    "Sorry, no disputes related to trip insurance were found on your account"
                  }
                </CText.kycTypeText>
                <View style={{ width: 170, height: 40 }}>
                  <CustomButton
                    text={"+Raise New Dispute"}
                    onPress={() => {props.setScreen("DisputeTransactions")
                }}
                  />
                </View>
              </View>
            ) : (
              <View
                style={{
                  alignItems: "flex-start",
                  marginTop: 20,
                  width: "100%",
                }}
              >
                <CText.basicInformationSubHeader>
                  {"Dispute Status"}
                </CText.basicInformationSubHeader>
                <CText.inputTopLabel>
                  {"List of trip insurance disputes raised"}
                </CText.inputTopLabel>
                <View
                  style={{
                    height: "100%",
                    width: "100%",
                    maxHeight: 310,
                    marginTop: 10,
                  }}
                >
                  {showDisputeDetails ? (
                    <View style={{ width: "80%", height: "80%" }}>
                      <TripDisputeDetailsCard data={disputeDetailData}/>
                      <View style={{width:140,height:40,marginTop:20,alignSelf:"center"}}>
                        <CustomButton onPress={() => setShowDisputeDetails(false)} text={"Back"}/>
                        </View>
                    </View>
                  ) : (
                    <ScrollView showsVerticalScrollIndicator={false}>
                        <FlatList 
                            data={data}
                            keyExtractor={item => item.id}
                            renderItem={({item}) => (
                                <TiDisputeStatusCard
                                onPress={() => {setDisputeDetailData(item)
                                    setShowDisputeDetails(true)}}
                                disputeId={item.transId}
                                statusTitle={item.recentDisputeStatus}
                              />
                            )}
                        />
                        
                    </ScrollView>
                  )}
                </View>
              </View>
            )}
          </View>
        </View>
      </View>
    </MainContainer>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#2c3e50",
    },
    contentWrapper: {
      width: "100%",
      height: "100%",
    },
    contentViewStyle: {
      flexDirection: "row",
      width: "100%",
      height: "100%%",
    },
    firstViewStyle: {
      width: "50%",
      alignItems: "center",
      paddingHorizontal: "12%",
      marginTop: 20,
    },
    secondViewStyle: {
      width: "50%",
      paddingHorizontal: "5%",
    },
    pdfViewStyle: {
      height: "60%",
      width: "100%",
    },
    textInputStyle: {
      width: 342,
      height: 56,
      borderRadius: 9,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#b9b9b9",
      marginTop: 10,
    },
    buttonContainerStyle: {
      flexDirection: "row",
      marginTop: 20,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
    overlayContentStyle: {
      width: "80%",
      height: "95%",
      backgroundColor: "white",
      borderRadius: 15,
      alignSelf: "center",
      justifyContent: "center",
      marginVertical: 10,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {
      contentViewStyle: {
        flexDirection: "column",
      },
      firstViewStyle: {
        width: "100%",
      },
      secondViewStyle: {
        width: "100%",
      },
    },
  }
);

//make this component available to the app
export default TripDisputeHome;
